import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const { inviteStripeBegin, inviteStripeSuccess, inviteStripeErr , disconnectStripeBegin ,disconnectStripeSuccess ,disconnectStripeErr} = actions;

const inviteStripeAPIName = '/admin/stripe-invitation';
const desconnecttripeAPIName = '/admin/stripe-disconnect';

const stripeInvitation = (values) => {
  return async (dispatch) => {
    dispatch(inviteStripeBegin());
    try {
      const response = await DataService.post(inviteStripeAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(inviteStripeErr(response?.data?.message));
      } else {
        dispatch(inviteStripeSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(inviteStripeErr(err));
    }
  };
};

const stripeDisconnect = (values) => {
  return async (dispatch) => {
    dispatch(disconnectStripeBegin());
    try {
      const response = await DataService.post(desconnecttripeAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(disconnectStripeErr(response?.data?.message));
      } else {
        dispatch(disconnectStripeSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(disconnectStripeErr(err));
    }
  };
};

export { stripeInvitation, stripeDisconnect };
